import Icon from './Icon';

const EmailList = ({ emails, title }: { emails: string[]; title: string }) => {
  return (
    <div className="mb-0">
      <h2 className="text-lg font-bold mb-2">{title}</h2>
      <ul className="list-none list-inside">
        {emails.map((email, index) => (
          <li key={index} className="mb-2 py-theme-xs">
            <a href={`mailto:${email}`} className="text-theme-link flex items-center gap-2">
              <div>
                <Icon name="envelope" />
              </div>
              <div>{email}</div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default EmailList;
